import { useLearnerProfileGroupsWidgetQuery } from '@/modules/learner/views/LearnerProfile/graphql/queries/generated/learnerProfileGroupsWidget';
import { LearnerWidgetProps } from '@/modules/learner/views/LearnerProfile/types';

import CardLoader from './CardLoader';
import LearnerGroupsWidget from './LearnerGroupsWidget';

const LearnerGroupsWidgetContainer = (props: LearnerWidgetProps) => {
  const { learner, onAction } = props;

  const [{ fetching, data, stale }] = useLearnerProfileGroupsWidgetQuery({
    variables: { learnerId: learner.id },
  });

  if ((fetching || stale) && !data?.user?.userGroups) {
    return <CardLoader />;
  }

  return (
    <LearnerGroupsWidget
      learnerId={learner.id}
      userGroups={data?.user?.userGroups ?? []}
      onAction={onAction}
    />
  );
};

export default LearnerGroupsWidgetContainer;
